import { useState, useEffect, useContext } from "react";
import GlobalContext from "@/context/GlobalContext";
import { meetingPreLogin, meetingRename } from "@/api/meeting";
import { FocusSDK, isFocusEnv } from "@/utils";
import { usePrevious } from "@/utils/chat/index";
import { findResourceIdInAuthorPermission } from "@/utils/envConfig";
import { AuthorResourceEnum } from "@/types/common";
import cache from "@/utils/cache";
import { NetType } from "../Modals/ChangeNetModal";

let retryCount = 0;

export default function ZoomLogin() {
  const [hasInit, setHasInit] = useState(false);
  const { authInfo, appRuntimeEnv, permissions, currentEmployee } = useContext(GlobalContext);
  const { selectedTeamId, teamUserInfo, userId } = authInfo;
  let ddAppId = teamUserInfo?.ddAppId || "";
  let teamId = teamUserInfo?.teamId || "";
  let realName = currentEmployee.name;
  const { zoom } = appRuntimeEnv;
  const preRef = usePrevious(`${selectedTeamId}:${ddAppId}:${userId}`);

  useEffect(() => {
    async function handleLoginCb({ status }: { status: number }) {
      if (status === 3) {
        console.error("zoom sdk login failure");
        cache.zoomLogin = false;
        return;
      }
      cache.zoomLogin = true;
      await meetingRename({
        appId: ddAppId,
        userId,
        teamId,
        fullName: realName || ""
      });
    }
    FocusSDK.on("zoom:loginCb", handleLoginCb);
    return () => {
      FocusSDK.off("zoom:loginCb", handleLoginCb);
    };
  }, [ddAppId, permissions, realName, teamId, userId, zoom.domain]);

  useEffect(() => {
    if (!isFocusEnv()) {
      return;
    }
    if (
      !(
        findResourceIdInAuthorPermission(permissions, AuthorResourceEnum.MEETING) ||
        findResourceIdInAuthorPermission(permissions, AuthorResourceEnum.MEETING_JOIN)
      )
    ) {
      return;
    }
    function getToken() {
      if (retryCount >= 3) {
        return;
      }
      if (!userId || !selectedTeamId || !ddAppId) {
        return;
      }
      if (hasInit && preRef === `${selectedTeamId}:${ddAppId}:${userId}`) {
        return;
      }
      setHasInit(true);
      FocusSDK.sendIpcMessage("zoom.initSdk");
    }
    // 如果是纯政务外网
    if (FocusSDK.getCurrentNetType() === NetType.PRIVATE_NET) {
      return;
    }
    getToken();
  }, [hasInit, permissions, preRef, selectedTeamId, ddAppId, teamId, userId, zoom.domain]);

  useEffect(() => {
    async function handleGetUserToken() {
      const [result, err] = await meetingPreLogin(ddAppId.replace("_", ""));
      if (err) {
        console.error("zoom getToken failure:", err);
        FocusSDK.sendIpcMessage("zoom:getUserTokenCb", {
          success: false
        });
        return;
      }
      FocusSDK.sendIpcMessage("zoom:getUserTokenCb", {
        success: true,
        password: result,
        username: userId
      });
    }
    FocusSDK.on("zoom.getUserToken", handleGetUserToken);
    return () => {
      FocusSDK.off("zoom.getUserToken", handleGetUserToken);
    };
  }, [ddAppId, userId]);

  return null;
}
